import { StarterKit } from '@tiptap/starter-kit';
import { Placeholder } from '@tiptap/extension-placeholder';
import { Underline } from '@tiptap/extension-underline';
import { TextAlign } from '@tiptap/extension-text-align';
import { Heading } from '@tiptap/extension-heading';
import { TaskItem } from '@tiptap/extension-task-item';
import { CharacterCount } from '@tiptap/extension-character-count';
import { ListItem } from '@tiptap/extension-list-item';
import { Link } from '@tiptap/extension-link';
import SlashCommandExtension from './SlashCommandExtension';
import FontSize from './FontSizeExtension';
import TextStyle from '@tiptap/extension-text-style';
import { ColorExtension } from './ColorExtension';
import Highlight from '@tiptap/extension-highlight';
import ImageUpload from './ImageUpload';
import ImageBlock from './ImageBlock';
import HorizontalRule from '@tiptap/extension-horizontal-rule';

interface TipTapExtensionKitOption {
  ai: {
    openGenerateWorksheetModal: () => void;
  };
}

export const TipTapExtensionKit = ({ ai }: TipTapExtensionKitOption) => [
  StarterKit.configure({
    heading: false,
    listItem: false,
    horizontalRule: false,
  }),
  Underline,
  Placeholder,
  TextAlign.configure({
    types: ['heading', 'paragraph'],
  }),
  Heading.configure({
    levels: [1, 2, 3],
  }),
  TaskItem.configure({
    nested: true,
  }),
  ListItem,
  CharacterCount.configure({
    limit: 10000,
  }),
  SlashCommandExtension({ ai }),
  TextStyle,
  FontSize,
  Link.configure({
    openOnClick: false,
  }),
  ColorExtension,
  Highlight.configure({ multicolor: true }),
  ImageUpload,
  ImageBlock,
  HorizontalRule,
];

export default TipTapExtensionKit;
